import mixpanel from "mixpanel-browser";

import { namespace } from "@formant/core/common/config";
import { logger } from "@formant/core/common/logger";

import { mixpanelToken } from "../config";
import { headless } from "./isHeadless";

// Allowlist: only view-usage events reach Mixpanel (Observe -> Coherence migration); this drops pre-auth events that mint MTUs and cuts event volume
const allowedEvents = new Set([
    "View Event",
    "View Device",
    "View Changed",
    "View Channel",
    "Teleop View Visit",
]);

// Global tracking context
const trackingContext: {
    viewId?: string;
    viewName?: string;
    groupName?: string;
    deviceName?: string;
    app?: string;
    baseViewName?: string;
    viewLayoutType?: string;
} = {};

// Export function to update tracking context
export function setTrackingContext(context: {
    viewId?: string;
    viewName?: string;
    groupName?: string;
    deviceName?: string;
    app?: string;
    baseViewName?: string;
    viewLayoutType?: string;
}) {
    Object.assign(trackingContext, context);
}

export function track(event: string, properties?: object) {
    // Drop everything that is not a view-usage event
    if (!allowedEvents.has(event)) {
        return;
    }

    if (namespace !== "prod") {
        logger.debug(`Track: ${event}`, { properties });
    }
    if (headless) {
        return;
    }
    if (mixpanelToken) {
        // Get additional context properties
        const additionalProps: Record<string, any> = {};

        // Always present on events for Insights breakdowns
        additionalProps.ApplicationName = "formant-web";

        // Add tracking context if available
        if (trackingContext.viewId) {
            additionalProps.ViewID = trackingContext.viewId;
        }
        if (trackingContext.viewName) {
            additionalProps.ViewName = trackingContext.viewName;
        }
        if (trackingContext.groupName) {
            additionalProps.GroupName = trackingContext.groupName;
        }
        if (trackingContext.deviceName) {
            additionalProps.DeviceName = trackingContext.deviceName;
        }
        if (trackingContext.app) {
            additionalProps.App = trackingContext.app;
        }
        if (trackingContext.baseViewName) {
            additionalProps.BaseViewName = trackingContext.baseViewName;
        }
        if (trackingContext.viewLayoutType) {
            additionalProps.ViewLayoutType = trackingContext.viewLayoutType;
        }

        const finalProperties = {
            ...additionalProps,
            ...properties,
        };

        mixpanel.track(event, finalProperties);
    }
}
